import { defineMessages } from "react-intl";

const PREFIX = "Favourites.NoFavouritesDialog";
export default defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Favourites",
  },
  contentText: {
    id: `${PREFIX}.contentText`,
    defaultMessage: "The Favourites section is empty",
  },
  discardAction: {
    id: `${PREFIX}.discardAction`,
    defaultMessage: "Ok",
  },
});
